module.exports = __webpack_public_path__ + "static/media/icon_type_select.33b30f2d.svg";